import { createPrefixer } from '@mews/framework';

export const HELP_CENTER_SIDEBAR_NAME = 'helpCenterSidebar';
export const MODULE_NAME = 'helpCenter';
export const prefix = createPrefixer(MODULE_NAME);
